import { render } from "./AppChip.vue?vue&type=template&id=4a65af4f&scoped=true&ts=true"
import script from "./AppChip.vue?vue&type=script&lang=ts"
export * from "./AppChip.vue?vue&type=script&lang=ts"

import "./AppChip.vue?vue&type=style&index=0&id=4a65af4f&lang=scss&scoped=true"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a65af4f"]])

export default __exports__